/**
 * Concept Archetype
 * 
 * @author Daniel Lepe
 * @date 25 de Sept, 2023
 * @version 1.0
 */

import _ from 'lodash'
import axios from 'axios'
import { store } from "@/store/store-init"

const baseController = 'listas'
const precioAproxLabel = 'Costo aproximado';
const baseIndex = baseController + '/index'
const createOrderURI = baseController + '/createorder'

const archetype = [
    {
        key: 'id',
        type: 'hidden'
    },
    {
        label: 'Cliente',
        key: 'usuario_id_pk',
        type: (store.getters.isRestaurant)? 'hidden' : 'remoteSelect',
        remote: 'ui/usuarios',
        default: store.getters.isRestaurant ? store.getters.authGetUser.id_pk : null,
        remoteCfg: {
            allowGrouping: true,
            dataGroup: 'inicial',
            allowFilter: true,
            // multiline: null,
        }
    },
    {
        key: 'lista_titulo',
        type: 'textarea'
    },
    {
        key: 'precio_aproximado',
        type: 'price',
        default: 0.0,
        readonly: true
    },
    {
        key: 'modified',
        type: 'hidden'
    },
    {
        key: 'created',
        type: 'hidden'
    },
    {
        key: 'detalleLista',
        default: [],
        type: 'hidden'
    }
];

let detalleArchetype = {
    // id: null,                // GESTIONADO DESDE API
    // usuario_listas_id: null, // GESTIONADO DESDE API
    cantidad: null,
    presentacion_id: null,
    id_pk_ingrediente: null,
    id_pk_articulo: null,
    fullObject: null
}

const captions = [
    { key: 'usuarioNombre', label: 'Cliente' },
    { key: 'usuario', label: 'Usuario' },
    { key: 'lista_titulo', label: 'Lista' },
    { key: 'precio_aproximado', label: precioAproxLabel },
    { key: 'created' },
    { key: 'modified' },
    { key: '_' },
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}

let createNewListDetail = ({cantidad, obj}) => {
    let data2return = _.clone(detalleArchetype);
    data2return.cantidad = cantidad
    data2return.presentacion_id = obj.presentacion_id_pk
    data2return.fullObject = obj;

    data2return[(parseInt(obj.tipo) == 1) ? 'id_pk_ingrediente' : 'id_pk_articulo'] = obj.idelemento_fk;

    // console.log('createNewListDetail', data2return, cantidad, obj)
    return data2return
}

let createOrderByListId = async  (orderId) => {
    let response = await axios.get(createOrderURI + '/' + orderId)
    return response;
}

export {
    archetype,
    captions,
    baseIndex,
    automodalHandler, 
    createNewListDetail,
    createOrderByListId
}